import {Injectable, Inject, Output} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DataList} from '../accounts/models/DataList';
import {IProduct, ISpecies} from '../accounts/interfaces/accounts-interface';
import {catchError} from 'rxjs/internal/operators/catchError';
import {throwError} from 'rxjs/internal/observable/throwError';
import {Observable} from 'rxjs/internal/Observable';
import {firstValueFrom} from 'rxjs/internal/firstValueFrom';
import {IRegion} from '../accounts/interfaces/accounts-interface';
import {PermissionHelper} from "src/app/helpers/permission.helper";
import {Permissions} from "src/app/shared/models/Permissions";
import {StringObject} from "src/app/shared/models/stringObject";
import {NavServiceService} from "src/app/shared/services/nav-service.service";
import {ObjectHolder} from "src/app/shared/models/objectHolder";
import {ActivatedRoute} from "@angular/router";


@Injectable({
    providedIn: 'root'
})
export class SupplyChainStateService {

    myAppUrl = '';
    _data: any;

    constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string, private _navService: NavServiceService) {
        this.myAppUrl = baseUrl;
    }
    
    public async checkRouteIDs(route: ActivatedRoute) {
        var distributorIdParam = route.snapshot.paramMap.get("distributorId");
        var groupIdParam = route.snapshot.paramMap.get("groupId");
        var siteIdParam = route.snapshot.paramMap.get("siteId");
        var businessActivityIdParam = route.snapshot.paramMap.get("businessActivityId");
        
        if (parseInt(distributorIdParam)) {
            await this.selectDistributorById(parseInt(distributorIdParam));
        }
        if (parseInt(groupIdParam)) {
            await this.selectGroupById(parseInt(groupIdParam));
        }
        if (parseInt(siteIdParam)) {
            await this.selectSiteById(parseInt(siteIdParam));
       }
       if (parseInt(businessActivityIdParam)) {
          await this.selectBusinessActivityById(parseInt(businessActivityIdParam));
       }
    }

    //******* Distributor *******//

    public get getSelectedDistributorId() {
        return this._navService.selectedAccounts.getSelectedDistributorId;
    }

    private selectedDistributorName: string;

    public get getSelectedDistributorName() {
        return this._navService.selectedAccounts.getSelectedDistributorName;
    }

    private selectedDistributorCanWhiteLabel: boolean = false;

    public get getSelectedDistributorCanWhiteLabel() {
        return this.selectedDistributorCanWhiteLabel;
    }

    private selectedDistributorEnablePostTreatmentCalculator: boolean = false;

    public get getSelectedDistributorEnablePostTreatmentCalculator() {
        return this.selectedDistributorEnablePostTreatmentCalculator;
    }

    public async setSelectedDistributor(id: number, name: string) {
        await this._navService.selectedAccounts.setSelectedDistributor(id, name);
        this.selectedDistributorCanWhiteLabel = await firstValueFrom(this.canDistributorWhiteLabel());
        this.selectedDistributorEnablePostTreatmentCalculator = await firstValueFrom(this.distributorEnablePostTreatmentCalculator());
        await this._navService.updateNavCounts();
    }

    public clearSelectedDistributor() {
        if (this.getSelectedDistributorId) {
            this._navService.selectedAccounts.clearSelectedDistributor();
            this.selectedDistributorCanWhiteLabel = false;
            this.selectedDistributorEnablePostTreatmentCalculator = false;
            this._navService.updateNavCounts();
        }
    }

    //******* Group *******//

    public get getSelectedGroupId() {
        return this._navService.selectedAccounts.getSelectedGroupId;
    }

    public get getSelectedGroupName() {
        return this._navService.selectedAccounts.getSelectedGroupName;
    }

    private selectedGroupCanWhiteLabel: boolean = false;

    public get getSelectedGroupCanWhiteLabel() {
        return this.selectedGroupCanWhiteLabel;
    }

    private selectedGroupEnablePostTreatmentCalculator: boolean = false;

    public get getSelectedGroupEnablePostTreatmentCalculator() {
        return this.selectedGroupEnablePostTreatmentCalculator;
    }

    public async setSelectedGroup(id: number, name: string) {
        await this._navService.selectedAccounts.setSelectedGroup(id, name);
        this.selectedGroupCanWhiteLabel = await firstValueFrom(this.canGroupWhiteLabel());
        this.selectedGroupEnablePostTreatmentCalculator = await firstValueFrom(this.groupEnablePostTreatmentCalculator());
        await this._navService.updateNavCounts();
    }

    public clearSelectedGroup() {
        if (this._navService.selectedAccounts.getSelectedGroupId) {
            this._navService.selectedAccounts.clearSelectedGroup();
            this.selectedGroupCanWhiteLabel = false;
            this.selectedGroupEnablePostTreatmentCalculator = false;
            this._navService.updateNavCounts();
        }
    }

    //******* Site *******//

    public get getSelectedSiteId() {
        return this._navService.selectedAccounts.getSelectedSiteId;
    }
    
    public get getSelectedSiteName() {
        return this._navService.selectedAccounts.getSelectedSiteName;
    }

    private selectedSiteCanWhiteLabel: boolean = false;

    public get getSelectedSiteCanWhiteLabel() {
        return this.selectedSiteCanWhiteLabel;
    }

    public async setSelectedSite(id: number, name: string) {
        await this._navService.selectedAccounts.setSelectedSite(id, name);
        this.selectedSiteCanWhiteLabel = await firstValueFrom(this.canSiteWhiteLabel());
        await this._navService.updateNavCounts();
    }

    public clearSelectedSite() {
        if (this.getSelectedSiteId) {
            this._navService.selectedAccounts.clearSelectedSite();
            this.selectedSiteCanWhiteLabel = false;
            this._navService.updateNavCounts();
        }
    }

   //******* Business activity *******//

   private selectedLaboratoryGroupBusinessActivityId: number;

   public get getSelectedLaboratoryGroupBusinessActivityId() {
      return this.selectedLaboratoryGroupBusinessActivityId;
   }

   private selectedBusinessActivityId: number;

   public get getSelectedBusinessActivityId() {
      return this._navService.selectedAccounts.getSelectedBusinessActivityId;
   }

   private selectedBusinessActivityName: string;

   public get getSelectedBusinessActivityName() {
      return this._navService.selectedAccounts.getSelectedBusinessActivityName;
   }

   public async setSelectedBusinessActivity(id: number, name: string, gid: number = null) {
      await this._navService.selectedAccounts.setSelectedBusinessActivity(id, name, gid);
      this.selectedBusinessActivityId = id;
      this.selectedBusinessActivityName = name;
      this.selectedLaboratoryGroupBusinessActivityId = gid;
   }

   public clearSelectedBusinessActivity() {
      if (this._navService.selectedAccounts.getSelectedBusinessActivityId) {
         this._navService.selectedAccounts.clearSelectedBusinessActivity();
         this._navService.updateNavCounts();
      }
   }
    
    async selectDistributorById(distributorId: number) {
        var result = await firstValueFrom(this._http.post<any>(`api/SupplyChainManagement/GetDistributorNameById`, new ObjectHolder(distributorId)).pipe(catchError(this.handleError)));
        if (result) {
            await this.setSelectedDistributor(result.item1, result.item2);
        }
    }

    async selectGroupById(groupId: number) {
        var result = await firstValueFrom(this._http.post<any>(`api/SupplyChainManagement/GetGroupNameById`, new ObjectHolder(groupId)).pipe(catchError(this.handleError)));
        if (result)
            await this.setSelectedGroup(result.item1, result.item2);
    }

    async selectSiteById(siteId: number) {
        var result = await firstValueFrom(this._http.post<any>(`api/SupplyChainManagement/GetSiteNameById`, new ObjectHolder(siteId)).pipe(catchError(this.handleError)));
        if (result)
            await this.setSelectedSite(result.item1, result.item2);
    }

   async selectBusinessActivityById(businessActivityId: number) {
      var result = await firstValueFrom(this._http.post<any>(`api/SupplyChainManagement/GetBusinessActivityNameById`, { item1: businessActivityId, item2: this.getSelectedGroupId }).pipe(catchError(this.handleError)));
      if (result)
         await this.setSelectedBusinessActivity(result.item1, result.item2);
   }

    public canDistributorWhiteLabel(): Observable<boolean> {
        return this._http
            .get<boolean>(this.myAppUrl + "api/SupplyChainManagement/DistributorCanWhiteLabel?distributorID=" + this._navService.selectedAccounts.getSelectedDistributorId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public distributorEnablePostTreatmentCalculator(): Observable<boolean> {
        return this._http
            .get<boolean>(this.myAppUrl + "api/SupplyChainManagement/DistributorEnablePostTreatmentCalculator?distributorID=" + this._navService.selectedAccounts.getSelectedDistributorId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public canGroupWhiteLabel(): Observable<boolean> {
        return this._http
            .get<boolean>(this.myAppUrl + "api/SupplyChainManagement/GroupCanWhiteLabel?groupID=" + this._navService.selectedAccounts.getSelectedGroupId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public groupEnablePostTreatmentCalculator(): Observable<boolean> {
        return this._http
            .get<boolean>(this.myAppUrl + "api/SupplyChainManagement/GroupEnablePostTreatmentCalculator?groupID=" + this._navService.selectedAccounts.getSelectedGroupId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public canSiteWhiteLabel(): Observable<boolean> {
        return this._http
            .get<boolean>(this.myAppUrl + "api/SupplyChainManagement/SiteCanWhiteLabel?siteID=" + this._navService.selectedAccounts.getSelectedSiteId)
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: Response) {
        return throwError(error.statusText);
    }

}
